import React from 'react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  return <section className="py-10 px-4 bg-cream-dark/30 border-y border-cream-dark" data-id="element-238">
      <div className="max-w-5xl mx-auto text-center" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block mb-6" data-id="element-240">
          <span className="bg-brand-green/10 text-brand-green font-bold px-4 py-2 rounded-full text-sm tracking-wider uppercase" data-id="element-241">
            Todo resuelto
          </span>
        </motion.div>

        <h2 className="md:text-5xl font-bold mb-4 flex items-center justify-center gap-3 text-[20px]" data-id="element-242">
          🏆 BIBLIOTECADIGITAL.ONLINE™ MEGAPACK COCINA
        </h2>

        <p className="text-xl md:text-2xl text-carbon-lighter mb-8 italic font-[600] font-[Avenir,_sans-serif]" data-id="element-243">
          6 Tomos + 3 Bonos + Upsell Marca Gourmet
        </p>

        <div className="bg-white inline-block px-8 py-4 rounded-2xl shadow-warm border border-cream-dark" data-id="element-244">
          <p className="text-2xl font-bold text-carbon" data-id="element-245">390 páginas</p>
        </div>

        <div className="mt-12 flex flex-wrap gap-[5px] items-start justify-center" data-id="element-246">
          {['Tomo 1: Salado', 'Tomo 2: Chipá', 'Tomo 3: Alfajores', 'Tomo 4: Pastafrolas, Budines y Muffins', 'Tomo 5: Galletitas', 'Tomo 6: Emprendedor'].map((tab, i) => <div key={i} className="bg-cream-light border border-cream-dark px-4 py-2 rounded-full text-sm font-medium text-carbon shadow-sm" data-id="element-247">
              {tab}
            </div>)}
        </div>
      </div>
    </section>;
}